import { useTranslation } from 'react-i18next';
import { getRoleDisplayLabel } from '../../app/helpers/specialistRoleModuleHelper';

const SpecialistRoleModulesPanel = ({
  roleName,
  modules = [],
  onToggleModule,
  onSelectAll,
  onDeselectAll
}) => {
  const { t } = useTranslation();
  const panelTitle = getRoleDisplayLabel(roleName, t);

  return (
    <div className="card flex-fill specialist-role-modules-panel" style={{ minWidth: '220px', maxWidth: '280px' }}>
      <div className="card-header py-2">
        <strong>{panelTitle}</strong>
      </div>
      <div className="card-body py-2">
        <div className="d-flex gap-2 mb-2 flex-wrap">
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={onSelectAll}>
            {t('admin.user_roles.select_all_modules')}
          </button>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onDeselectAll}>
            {t('admin.user_roles.deselect_all_modules')}
          </button>
        </div>
        <ul className="list-group list-group-flush">
          {modules.map(({ id, name, value }) => (
            <li key={id} className="list-group-item px-0 py-1">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`module-${roleName}-${id}`}
                  checked={!!value}
                  onChange={() => onToggleModule(id)}
                />
                <label className="form-check-label" htmlFor={`module-${roleName}-${id}`}>
                  {name}
                </label>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SpecialistRoleModulesPanel;
